export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q02_b.331786bd.png";